// 用户登录信息
export default {
    namespaced: true,
    state: {
        user: window.localStorage.getItem("user")
            ? JSON.parse(window.localStorage.getItem("user"))
            : window.sessionStorage.getItem('user')?JSON.parse(window.sessionStorage.getItem('user')):"", // 用户信息(id，token等)
        // token: window.localStorage.getItem("token")
        //     ? window.localStorage.getItem("token")
        //     : "", // 是否登录标志
        token: window.localStorage.getItem("token")
        ? window.localStorage.getItem("token")
        : window.sessionStorage.getItem('token')?window.sessionStorage.getItem('token'):"",
        authorization:window.sessionStorage.getItem('authorization')? window.sessionStorage.getItem('authorization'):false

    },
    getters: {

    },
    mutations: {
        // 登录
        login (state, value) {
            state.user = value.user;
            state.token = value.token;
            window.localStorage.setItem("user", JSON.stringify(value.user));
            window.localStorage.setItem("token", value.token);
        },
        // 登录
        loginTemp (state, value) {
            state.user = value.user;
            state.token = value.token;
            window.sessionStorage.setItem("user", JSON.stringify(value.user));
            window.sessionStorage.setItem("token", value.token);
        },
        // 退出登录
        logOut (state) {
            state.user = null;
            state.token = null;
            window.localStorage.removeItem("user");
            window.sessionStorage.removeItem("user");
            window.localStorage.removeItem("token");
            window.sessionStorage.removeItem("token");
        },
        setAuthorization(state,value){
            window.sessionStorage.setItem('authorization',value)
        }
    },
    actions: {
    },
}